import React, { FC } from 'react';
import { Wrapper } from './styles';
import { AppointmentTypeAdd, SideMenu } from 'features';

const AppointmentTypeAddPage: FC = () => {
  return (
    <Wrapper>
      <SideMenu />
      <AppointmentTypeAdd />
    </Wrapper>
  );
};

export default AppointmentTypeAddPage;
